import {Component, effect, EventEmitter, Input, OnInit, Output, signal, WritableSignal} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {ButtonDirective} from "primeng/button";
import {Ripple} from "primeng/ripple";
import {LeafletModule} from "@bluehalo/ngx-leaflet";
import * as L from 'leaflet';
import 'leaflet-draw';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { point } from '@turf/helpers';
import type { Feature, Polygon, MultiPolygon } from 'geojson';


import {LeafletMouseEvent} from "leaflet";
import {DraftProjectService} from "../../../../services/draft-project.service";
import {GeoMapService} from "../../services/geo-map.service";
import {SharedModule} from "../../../../../../shared/shared.module";
import {NgIf} from "@angular/common";
import type { GeoJsonObject } from 'geojson';

@Component({
  selector: 'app-leaflet-map',
  standalone: true,
    imports: [
        DialogModule,
        ButtonDirective,
        Ripple,
        LeafletModule,
        SharedModule,
        NgIf
    ],
  templateUrl: './leaflet-map.component.html',
  styleUrl: './leaflet-map.component.scss'
})
export class LeafletMapComponent implements OnInit {
    @Input() dialogLeafletView: boolean = false;
    @Output() onCloseLeaflet = new EventEmitter<boolean>;
    mapa!: L.Map;
    marcadorActual: L.Marker | null = null;
    // poligonoRegulado!: GeoJsonObject
    poligonoRegulado!: Feature<Polygon | MultiPolygon>;
    options = {
        layers: [
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors'
            })
        ],
        zoom: 9,
        center: L.latLng(13.6929, -89.2182)
    };
    markerSelected: WritableSignal<L.LatLng | null> = signal(null); // obtener las coordenadas del punto seleccionado
    constructor(protected draftProjectService : DraftProjectService, protected geoMapService:GeoMapService) {
    }
    ngOnInit() {
        console.log(`ngOnInit ->${this.constructor.name}` + new Date().toISOString());
       this.getGeoPoligonos()
    }

    private getGeoPoligonos() {
        let regulados= ['0','1']
        this.geoMapService.getGeoPoligonos(regulados).subscribe({
            next: (geojson) => {
                if (geojson && geojson.length > 0) {
                    this.poligonoRegulado = geojson[0];
                    this.geoMapService.datosCargado.set(true);
                }
            },
            error: (err) => {
                console.error('Error al cargar datos getGeoPoligonoRegulado:', err);
            },
            complete: () => {
            }
        });
    }


    onClicMapMarker($event: LeafletMouseEvent) {
        // polígono o multi-polígono en formato GeoJSON
        if (!this.poligonoRegulado) {
            console.log("El polígono no tiene coordenadas definidas.");
            return;
        }
        let coords = $event.latlng
        if (this.marcadorActual) { // validacion para que solo permitir marcar y visualizar un punto ala vez
            this.mapa.removeLayer(this.marcadorActual);
        }

        this.marcadorActual = L.marker([coords.lat!,coords.lng!], {})
            .addTo(this.mapa)
        this.markerSelected.set(coords);
        this.closeLeaflet();
        //TODO: este codigo permite validar si el punto está dentro territorio DOT regulado con la informacion que viene del BE
        // const punto = point([coords.lng, coords.lat]);
        // const isValid = booleanPointInPolygon(punto, this.poligonoRegulado);
        // if (isValid) {
        // }else{
        //     console.log("Error este territo no es regulado por la dot")
        //     L.popup().setLatLng([coords.lat, coords.lng]).setContent("Este territorio no es regulado por la DOT")
        //         .openOn(this.mapa);
        // }

    }

    onMapReady(map: L.Map) {
        this.mapa = map;
        //1- iconos personalizados
        delete (L.Icon.Default.prototype as any)._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: '/assets/demo/images/leaflet/marker-icon-2x.png',
            iconUrl: '/assets/demo/images/leaflet/marker-icon.png',
            shadowUrl: '/assets/demo/images/leaflet/marker-shadow.png'
        });

        //2- Mostrar marcador seleccionado si existe
        this.refreshCoords();
        const point = this.markerSelected();
        if (point) {
            this.marcadorActual = L.marker([point.lat, point.lng])
                .addTo(this.mapa)
            this.mapa.setView(this.marcadorActual.getLatLng(), 14); //permite hacer zoom
        }

        //4- Verificar data del  GeoJSON si ya fue cargado para luego dibujarlo
        if (this.poligonoRegulado) {
            const geoLayer = L.geoJSON(this.poligonoRegulado, {
                style: (feature) => {
                    let color= feature?.properties.color;
                    return {
                        color: color,
                        weight: 1,
                        opacity: 0.65
                    };
                }
            }).addTo(this.mapa);
            // Solo hacer fitBounds si no hay punto seleccionado
            if (!point) {
                this.mapa.fitBounds(geoLayer.getBounds());
            }

        }else{
            console.log("poligonoRegulado indefinido:", this.poligonoRegulado);
        }

    }
// Función que solo maneja el bindPopup con la descripcion para cada feature en el GeoJSON
    onEachFeature(feature: any, layer: any) {
        if (feature.properties?.descripcion) {
            // Muestra el popup solo cuando el mouse pasa sobre el polígono
            layer.on('mouseover', (event: any) => {
                this.mapa.closePopup(); // Este método cierra todos los popups abiertos en el mapa
                layer.bindPopup(feature.properties.descripcion).openPopup();
            });

            // Cierra el popup cuando el mouse sale del área del polígono
            layer.on('mouseout', () => {
                layer.closePopup();
            });

            // Cierra el popup cuando se hace clic en el área del polígono
            layer.on('click', () => {
                layer.closePopup();
            });
        }
    }


    closeLeaflet() {
        this.dialogLeafletView = false;
        this.onCloseLeaflet.emit(this.dialogLeafletView);
    }
    //Metodo que refresca las coordenadas si ya existen en la variable signal cuando se refrescar la pagina y permitir visualizar el punto
    private refreshCoords() {
        if(this.draftProjectService.draftProject().ubicacionItem.latitud!==0 || this.draftProjectService.draftProject().ubicacionItem.longitud!==0){
            this.marcadorActual = L.marker([this.draftProjectService.draftProject().ubicacionItem.latitud, this.draftProjectService.draftProject().ubicacionItem.longitud])
            this.markerSelected.set(this.marcadorActual.getLatLng())
        }else{console.log("las coordenadas igual a cero")}
    }

    //Metodo que detecta cuando se seleccionaron las coordenadas y se procede actualizar la signal
    markerEffect = effect(
        () => {
            const marker = this.markerSelected();
            if (marker) {
                this.draftProjectService.draftProject.update((current) => ({
                    ...current,
                    ubicacionItem: {matricula: current.ubicacionItem.matricula, claveCatastral: current.ubicacionItem.claveCatastral,
                        latitud: marker.lat, longitud: marker.lng
                    }
                }));
            }
        },
        {allowSignalWrites: true});

    ngOnDestroy(): void {
        console.log(`ngOnDestroy ->${this.constructor.name}` + new Date().toISOString());
        this.geoMapService.datosCargado.set(false);
    }

}
